import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-setup-verification-dialog',
  templateUrl: './setup-verification-dialog.component.html',
  styleUrls: ['./setup-verification-dialog.component.css']
})
export class SetupVerificationDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<SetupVerificationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}
